// Return headers for authenticated requests and set axios common headers for convenience
import axios from "axios";

export default function authHeader() {
  let token = null;
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    token = (user && (user.accessToken || user.token || user.access_token)) || null;
  } catch (e) {
    token = null;
  }

  if (token) {
    // Provide both common Authorization and x-access-token to satisfy different backends
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.defaults.headers.common["x-access-token"] = token;
    const headers = { Authorization: `Bearer ${token}`, "x-access-token": token };

    const viewAsRole = sessionStorage.getItem("mtc_view_as_role");
    if (viewAsRole) {
      headers["x-view-as-role"] = viewAsRole;
      axios.defaults.headers.common["x-view-as-role"] = viewAsRole;
    } else {
      delete axios.defaults.headers.common["x-view-as-role"];
    }

    const viewAsUser = sessionStorage.getItem("mtc_view_as_user");
    if (viewAsUser) {
      headers["x-view-as-user"] = viewAsUser;
      axios.defaults.headers.common["x-view-as-user"] = viewAsUser;
    } else {
      delete axios.defaults.headers.common["x-view-as-user"];
    }

    return headers;
  }

  // Ensure defaults are cleared when no token
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["x-access-token"];
  delete axios.defaults.headers.common["x-view-as-role"];
  delete axios.defaults.headers.common["x-view-as-user"];
  return {};
}
